import { STATUS_FILTER_DISABLED, STATUS_FILTER_ENABLED } from '../actions/status_filter'
import { LOGOUT_SUCCESS } from '../actions'

export function statusFilter(state = { statusFilter: null }, action) {
  switch (action.type) {
    case STATUS_FILTER_ENABLED:
      return { ...state, statusFilter: action.statusFilter }
    case STATUS_FILTER_DISABLED:
      return { ...state, statusFilter: action.statusFilter }
    case LOGOUT_SUCCESS:
      return { ...state, statusFilter: [] }
    default:
      return state
  }
}
